<div class="modal-header relative border-b pb-3 mb-4">
<h3 class="text-xl font-semibold">Add New Credit Card</h3>
<button (click)="closeModal('cancel')" class="absolute top-0 right-0 text-gray-500 hover:text-gray-900 focus:outline-none" title="Close">
<svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
</button>
</div>

<!-- Loading and Error States -->

<div class="modal-content" style="position: relative; height: 500px;">

<div *ngIf="loading" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center;">
    <div class="spinner-border" role="status"></div>
    <p style="margin-top: 10px;">Loading Secure Payment Form...</p>
</div>

<div *ngIf="systemError" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: red; text-align: center;">
    <p>Error loading payment form. Please try again.</p>
    <button (click)="closeModal('cancel')" class="mt-4 p-2 bg-gray-200 rounded">Close</button>
</div>

<!-- SUCCESS OVERLAY (Appears after successful redirect detection) -->
<div *ngIf="paymentSuccessful" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; justify-content: center; align-items: center; background-color: #f7fff7; border-radius: 8px; z-index: 20;">
    <div style="text-align: center; padding: 20px;">
        <h3 style="color: #5cb85c;">Success!</h3>
        <p style="font-size: 1.1em;">Your new credit card has been added.</p>
        <p style="font-size: 0.9em; color: #666; margin-top: 5px;">Refreshing card list...</p>
    </div>
</div>

<!-- IFRAME CONTAINER -->
<div class="iframe-placeholder" [style.visibility]="loading || paymentSuccessful ? 'hidden' : 'visible'" [style.height]="loading || paymentSuccessful ? '0' : '100%'">
    <iframe
        #addPaymentIframe  
        id="add_payment"
        style="width: 100%; height: 100%; border: none;"  
        name="authorizeNetIframe"
    ></iframe>
</div>

</div>
